(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cantemiri-carousel"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('cm-banner-carousel')) {
  customElements.define('cm-banner-carousel', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      clearTimeout(this.timer);
      this.slides = [...this.querySelectorAll('[data-slide]')];
      this.index = 0;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      if (this.slides.length < 2) return;
      this.querySelector('[data-controls]').hidden = false;
      this.querySelector('[data-prev]').addEventListener('click', () => this.show(this.index - 1), options);
      this.querySelector('[data-next]').addEventListener('click', () => this.show(this.index + 1), options);
      this.querySelectorAll('[data-index]').forEach(button => button.addEventListener('click', () => this.show(Number(button.dataset.index)), options));
      document.addEventListener('shopify:block:select', event => {
        const index = this.slides.findIndex(slide => slide.dataset.blockId === event.detail.blockId);
        if (index >= 0) this.show(index);
      }, options);
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.motion.addEventListener('change', () => this.schedule(), options);
      document.addEventListener('visibilitychange', () => this.schedule(), options);
      this.addEventListener('focusin', () => this.schedule(), options);
      this.addEventListener('focusout', () => queueMicrotask(() => this.schedule()), options);
      this.show(0);
    }
    show(index) {
      this.index = (index + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, i) => { slide.hidden = i !== this.index; slide.inert = i !== this.index; });
      this.querySelectorAll('[data-index]').forEach((button, i) => { if (i === this.index) button.setAttribute('aria-current', 'true'); else button.removeAttribute('aria-current'); });
      this.dataset.activeSlide = String(this.index + 1);
      this.schedule();
    }
    schedule() {
      clearTimeout(this.timer);
      if (document.hidden || this.motion?.matches || this.contains(document.activeElement)) return;
      this.timer = setTimeout(() => this.show(this.index + 1), 7000);
    }
    disconnectedCallback() { clearTimeout(this.timer); this.controller?.abort(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cantemiri-home-premium"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('cm-premium-home')) {
  customElements.define('cm-premium-home', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      clearTimeout(this.timer);

      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.slides = [...this.querySelectorAll('[data-slide]')];
      this.index = 0;
      this.hero = this.querySelector('.cm-home-hero');
      this.dots = [...this.querySelectorAll('[data-hero-dot]')];
      this.rotation = this.querySelector('[data-hero-rotation]');
      this.paused = false;
      this.canHover = window.matchMedia('(hover: hover) and (pointer: fine)');
      this.dots.forEach((dot) => dot.addEventListener('click', () => this.show(Number(dot.dataset.heroDot)), options));
      this.rotation?.addEventListener('click', () => {
        this.paused = !this.paused;
        this.rotation.setAttribute('aria-pressed', String(this.paused));
        this.rotation.setAttribute('aria-label', this.paused ? this.rotation.dataset.playLabel : this.rotation.dataset.pauseLabel);
        this.schedule();
      }, options);
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.mobileHero = window.matchMedia('(max-width: 899px)');
      this.heroStage = this.querySelector('[data-stage]');

      if (this.heroStage) {
        let heroStartX = 0;
        let heroStartY = 0;
        let heroSwiped = false;

        this.heroStage.addEventListener('touchstart', (event) => {
          if (!this.mobileHero.matches || event.touches.length !== 1) return;
          const touch = event.touches[0];
          heroStartX = touch.clientX;
          heroStartY = touch.clientY;
          heroSwiped = false;
          clearTimeout(this.timer);
        }, { ...options, passive: true });

        this.heroStage.addEventListener('touchend', (event) => {
          if (!this.mobileHero.matches || event.changedTouches.length !== 1) return;
          const touch = event.changedTouches[0];
          const deltaX = touch.clientX - heroStartX;
          const deltaY = touch.clientY - heroStartY;

          if (Math.abs(deltaX) < 50 || Math.abs(deltaX) <= Math.abs(deltaY) * 1.2) {
            this.schedule();
            return;
          }

          heroSwiped = true;
          this.show(this.index + (deltaX < 0 ? 1 : -1));

          window.setTimeout(() => {
            heroSwiped = false;
          }, 250);
        }, { ...options, passive: true });

        this.heroStage.addEventListener('touchcancel', () => this.schedule(), { ...options, passive: true });

        this.heroStage.addEventListener('click', (event) => {
          if (!heroSwiped) return;
          event.preventDefault();
          event.stopPropagation();
        }, { ...options, capture: true });
      }

      this.lovedTrack = this.querySelector('[data-loved-track]');
      this.querySelector('[data-loved-prev]')?.addEventListener('click', () => {
        if (!this.lovedTrack) return;
        this.lovedTrack.scrollBy({ left: -this.lovedTrack.clientWidth * 0.78, behavior: this.reducedMotion.matches ? 'auto' : 'smooth' });
      }, options);
      this.querySelector('[data-loved-next]')?.addEventListener('click', () => {
        if (!this.lovedTrack) return;
        this.lovedTrack.scrollBy({ left: this.lovedTrack.clientWidth * 0.78, behavior: this.reducedMotion.matches ? 'auto' : 'smooth' });
      }, options);

      this.recTrack = this.querySelector('[data-rec-track]');
      this.querySelector('[data-rec-prev]')?.addEventListener('click', () => {
        if (!this.recTrack) return;
        this.recTrack.scrollBy({ left: -this.recTrack.clientWidth * 0.78, behavior: this.reducedMotion.matches ? 'auto' : 'smooth' });
      }, options);
      this.querySelector('[data-rec-next]')?.addEventListener('click', () => {
        if (!this.recTrack) return;
        this.recTrack.scrollBy({ left: this.recTrack.clientWidth * 0.78, behavior: this.reducedMotion.matches ? 'auto' : 'smooth' });
      }, options);

      this.hero?.addEventListener('mouseenter', () => { if (this.canHover.matches) clearTimeout(this.timer); }, options);
      this.hero?.addEventListener('mouseleave', () => this.schedule(), options);
      this.hero?.addEventListener('focusin', () => clearTimeout(this.timer), options);
      this.hero?.addEventListener('focusout', () => queueMicrotask(() => this.schedule()), options);
      document.addEventListener('visibilitychange', () => this.schedule(), options);
      this.reducedMotion.addEventListener('change', () => this.schedule(), options);

      this.observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) entry.target.classList.add('is-visible');
        });
      }, { threshold: 0.12 });

      this.querySelectorAll('.cm-home-reveal').forEach((element) => this.observer.observe(element));

      this.show(0);
    }

    show(index) {
      if (!this.slides.length) return;
      this.index = (index + this.slides.length) % this.slides.length;

      this.slides.forEach((slide, i) => {
        const active = i === this.index;
        slide.classList.toggle('is-active', active);
        if (active) {
          slide.removeAttribute('aria-hidden');
          slide.inert = false;
        } else {
          slide.setAttribute('aria-hidden', 'true');
          slide.inert = true;
        }
      });

      this.dots.forEach((dot, i) => dot.setAttribute('aria-current', String(i === this.index)));
      const nextImage = this.slides[(this.index + 1) % this.slides.length]?.querySelector('img');
      if (nextImage) nextImage.loading = 'eager';
      this.schedule();
    }

    schedule() {
      clearTimeout(this.timer);
      if (this.slides.length < 2 || document.hidden || this.paused || this.reducedMotion.matches || (this.canHover.matches && this.hero?.matches(':hover')) || this.hero?.contains(document.activeElement)) return;
      this.timer = setTimeout(() => this.show(this.index + 1), 10000);
    }

    disconnectedCallback() {
      clearTimeout(this.timer);
      this.observer?.disconnect();
      this.controller?.abort();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
